module.exports = __webpack_public_path__ + "static/home-office-fbf3953d0a19100bdbe25d1fba1d8517.jpeg";